import { FileRemovedFromTemplateEvent } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type FileRemovedFromTemplateDetailProps = {
  event: FileRemovedFromTemplateEvent;
};

const formatFileSize = (size: bigint): string => {
  const bytes = Number(size);
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const FileRemovedFromTemplateDetail = ({
  event,
}: FileRemovedFromTemplateDetailProps) => {
  const file = event.file;
  const removedAtStr = protoTimestampToZonedDateTimeString(event.removedAt);

  if (!file) {
    return (
      <Col className="@FileRemovedFromTemplateDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FileRemovedFromTemplateDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          File Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={file.id?.value} />
          <FieldDisplay label="File Name" value={file.fileName} />
          <FieldDisplay
            label="File Size"
            value={formatFileSize(file.fileSize)}
          />
          <FieldDisplay label="MIME Type" value={file.mimeType} />
        </div>
      </Col>

      <Col
        className="rounded-md border border-warning/20 bg-warning/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-warning/80">
          Template Removal Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay label="Removed By" value={event.removedBy} />
          {removedAtStr && (
            <FieldDisplay
              label="Removed At"
              value={humanReadableDateTime(removedAtStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
